import moment from 'moment/moment';

export const convertCalendarObjectToArray = (calendarObject) => {
  const calendarArray = [];
  for (const [date, events] of Object.entries(calendarObject)) {
    let shiftName = [];
    let shiftType = [];
    let groupName = [];
    let groupColor = [];
    for (const event of events) {
      shiftName.push(event.shiftName);
      shiftType.push(event.shiftType);
      groupName.push(event.groupName);
      groupColor.push(event.groupColor);
    }
    const transformedEvent = {
      shiftName: shiftName,
      shiftType: shiftType,
      groupName: groupName,
      groupColor: groupColor,
      date,
    };
    calendarArray.push(transformedEvent);
  }

  return calendarArray;
};

export function swapKeysAndValues(originalObject) {
  return Object.fromEntries(
    Object.entries(originalObject).map(([key, value]) => [value, key])
  );
}

export function formateDate(date, from = 'YYYY-MM-DD') {
  return moment(date, from).format('dddd Do MMMM YYYY');
}

export function formateDate2(date, from = 'YYYY-MM-DD') {
  return moment(date, from).format('ddd Do MMM YYYY');
}

export function formateDateMonth(date, from = 'YYYY-MM-DD') {
  return moment(date, from).format('Do MMMM');
}

export function formatDateWithSuffix(date) {
  const daysOfWeek = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  const day = date.getDate();
  const ordinalSuffix = getOrdinalSuffix(day);

  const formattedDate = `${daysOfWeek[date.getDay()]} ${day}${ordinalSuffix}`;

  return formattedDate;
}

export function getOrdinalSuffix(day) {
  if (day >= 11 && day <= 13) {
    return 'th';
  }

  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}

// export function varFormatTime(input, defFormat = '24') {
//   // 18:00-20:00
//   // (18:00 - 20:00)
//   // 05/05/2025 15:13:45
//   var format = defFormat;

//   const to12Hour = (date) => {
//     return moment(date).format('hh:mm A');
//   };

//   const to24Hour = (date) => {
//     return moment(date).format('HH:mm');
//   };

//   const formatDate = (date) => {
//     return moment(date).format('MM/DD/YYYY');
//   };

//   const parseTime = (timeStr) => {
//     const [hours, minutes] = timeStr.split(':').map(Number);
//     const date = new Date();
//     date.setHours(hours, minutes, 0, 0);
//     return date;
//   };

//   // Remove outer parentheses and trim
//   let cleanedInput = input
//     .trim()
//     .replace(/^\(+|\)+$/g, '')
//     .trim();

//   // Normalize dashes and remove extra spaces: "18:00 - 20:00" → "18:00-20:00"
//   cleanedInput = cleanedInput.replace(/\s*-\s*/g, '-');

//   // Time range case "18:00-20:00"
//   if (/^\d{1,2}:\d{2}(:\d{2})?-\d{1,2}:\d{2}(:\d{2})?$/.test(cleanedInput)) {
//     const [start, end] = cleanedInput.split('-');
//     const showSeconds =
//       start.split(':').length === 3 || end.split(':').length === 3;
//     const startDate = parseTime(start);
//     const endDate = parseTime(end);

//     if (format === '12') {
//       return `${to12Hour(startDate, showSeconds)} - ${to12Hour(
//         endDate,
//         showSeconds
//       )}`;
//     } else {
//       return `${to24Hour(startDate, showSeconds)} - ${to24Hour(
//         endDate,
//         showSeconds
//       )}`;
//     }
//   }

//   // Full datetime case "05/05/2025 15:13:45"
//   const datetime = new Date(input);
//   if (!isNaN(datetime.getTime())) {
//     const dateStr = formatDate(datetime);
//     const timeStr = format === '12' ? to12Hour(datetime) : to24Hour(datetime);
//     return `${dateStr} ${timeStr}`;
//   }
//   return input;
// }

export function varFormatTime(input, defFormat = '24') {
  var format = defFormat;

  const to12Hour = (date, showSeconds = false) => {
    return moment(date).format(showSeconds ? 'hh:mm:ss A' : 'hh:mm A');
  };

  const to24Hour = (date, showSeconds = false) => {
    return moment(date).format(showSeconds ? 'HH:mm:ss' : 'HH:mm');
  };

  const formatDate = (date) => { 
    return moment(date).format('MM/DD/YYYY');
  };

  const parseTime = (timeStr) => {
    const parts = timeStr.split(':').map(Number);
    const date = new Date();
    if (parts.length === 2) {
      date.setHours(parts[0], parts[1], 0, 0);
    } else if (parts.length === 3) {
      date.setHours(parts[0], parts[1], parts[2], 0);
    }
    return date;
  };

  // Remove outer parentheses and trim
  let cleanedInput = input
    .trim()
    .replace(/^\(+|\)+$/g, '')
    .trim();

  // Normalize dashes and remove extra spaces: "18:00 - 20:00" → "18:00-20:00"
  cleanedInput = cleanedInput.replace(/\s*-\s*/g, '-');

  // Time range case: "18:00-20:00" or "18:00:00-20:00:00"
  if (/^\d{1,2}:\d{2}(:\d{2})?-\d{1,2}:\d{2}(:\d{2})?$/.test(cleanedInput)) {
    const [start, end] = cleanedInput.split('-');
    const showSeconds =
      start.split(':').length === 3 || end.split(':').length === 3;
    const startDate = parseTime(start);
    const endDate = parseTime(end);

    return format === '12'
      ? `${to12Hour(startDate, showSeconds)} - ${to12Hour(endDate, showSeconds)}`
      : `${to24Hour(startDate, showSeconds)} - ${to24Hour(endDate, showSeconds)}`;
  }

  // Single time case: "18:00" or "18:00:00"
  if (/^\d{1,2}:\d{2}(:\d{2})?$/.test(cleanedInput)) {
    const showSeconds = cleanedInput.split(':').length === 3;
    const date = parseTime(cleanedInput);
    return format === '12'
      ? to12Hour(date, showSeconds)
      : to24Hour(date, showSeconds);
  }

  // Full datetime case: "05/05/2025 15:13:45"
  const datetime = new Date(input);
  if (!isNaN(datetime.getTime())) {
    const dateStr = formatDate(datetime);
    const timeStr = format === '12'
      ? to12Hour(datetime, true)
      : to24Hour(datetime, true);
    return `${dateStr} ${timeStr}`;
  }

  return input; // fallback for unrecognized formats
}

export function checkIsObject(val) {
  return val !== null && typeof val === "object" && !Array.isArray(val);
}

export function calculatePercentageChange(current, previous) {
  if (previous === null || previous === undefined || previous === 0) {
    return current > 0 ? 100 : 0;
  }

  const percentageChange = ((current - previous) / previous) * 100;
  return parseFloat(percentageChange.toFixed(1));
}